import { DynamicStandaloneLink, DynamicStandaloneLinkProps } from '@/components/Link';
import { componentTheme } from '@/styles/ShowsSlider';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type ShowsSliderLinkProps = DynamicStandaloneLinkProps;

export const ShowsSliderLinkComponent: StandaloneComponent<ShowsSliderLinkProps> = (props) => {
  return (
    <DynamicStandaloneLink
      {...mergeProps(
        {
          options: {
            theme: componentTheme('link'),
          },
        },
        props
      )}
    />
  );
};
